import Modal from './Modal';
import _template from 'lodash/template';
import ModalBeforeAfterTpl from '../templates/modal--before-after.html';

class ModalBeforeAfter extends Modal {
  constructor(el, mobileClose) {
    super(el);
    this.modal = this;
    this.mobileClose = mobileClose;
  }

  onOpenModal(e) {
    this.dom.$container = $(
      '<div></div>'
    );
    const currentTarget = $(e.currentTarget);
    const beforeAfterParent = currentTarget.parents('.before-after');
    const currentTargetContainer = currentTarget.parents('.before-after__slide__content');
    this.modalIndex = currentTarget.data('modalIndex');
    const rtf = currentTargetContainer.find('.rtf-content-block').html();
    const inBeforeAfterImages = beforeAfterParent.find(`.before-after__slider__slide[data-modal-index='${this.modalIndex}']`).find('.icv__img-b')[0].getAttribute('src');
    const images = [
      inBeforeAfterImages,
      ...window.BEFORE_AFTER_IMAGES[this.modalIndex]
    ];
    this.sliderData = {
      images,
      rtf,
      total: images.length,
      mobileClose: this.mobileClose
    }
    super.onOpenModal(e);
  }

  getContent() {
    this.dom.$container.append(_template(ModalBeforeAfterTpl)({
      data: this.sliderData
    }));
    return { content: this.dom.$container.html() };
  }

  showModal() {
    super.showModal();
    const $modal = $('#modal');
    const headerOffset = document.querySelector('header').offsetHeight;
    const mediaSlider = this.dom.$modalContent.find('.modal--before-after__media__slider');
    $modal.addClass('modal--before-after');
    if (window.innerWidth < 1024) {
      $modal.css({ top: `${headerOffset}px`, height: `calc(100vh - ${headerOffset}px)` })
      this.dom.$modalContent.find('.modal--before-after__mobile-close').on('click', e => super.closeModal(e.currentTarget))
    }
    this.initMediaSlider(mediaSlider);
    this.createMediaSliderPaginationLite(mediaSlider, 0);
    this.createGridImagesEvents(mediaSlider);
  }

  initMediaSlider(mediaSlider) {
    const prevArrow = this.dom.$modalContent.find('.slick-prev');
    const nextArrow = this.dom.$modalContent.find('.slick-next');
    mediaSlider.slick({
      adaptiveHeight: false,
      variableWidth: false,
      infinite: false,
      arrows: true,
      prevArrow,
      nextArrow,
      slidesToShow: 1,
      lazyLoad: 'ondemand'
    });
    mediaSlider.on('beforeChange', (e, s, c, next) => this.createMediaSliderPaginationLite(mediaSlider, next));
  }

  createGridImagesEvents(mediaSlider) {
    this.dom.$modalContent.find('.modal--before-after__small-images img').each((index, element) => {
      $(element).click(() => mediaSlider.slick('slickGoTo', index, false))
    })
  }

  createMediaSliderPaginationLite(mediaSlider, currentSlide) {
    const pagesLength = this.sliderData.images.length;
    const paginationContainer = this.dom.$modalContent.find('.modal--before-after__pagination');
    const paginationHtml = `
      <button>${currentSlide+1}</button>
      <span>/</span>
      <button>${pagesLength}</button>
    `;
    paginationContainer.html(paginationHtml)
    paginationContainer.find('button').click(e => (
      mediaSlider.slick('slickGoTo', e.currentTarget.dataset.modalIndex)
    ));
  }
}

export default ModalBeforeAfter;



// WEBPACK FOOTER //
// ./src/btu/js/components/ModalBeforeAfter.js